import ExcelJS from 'exceljs';

type NumericValue = number | string | null;

export interface RelatorioItem {
  ID?: number;
  DATA?: string;
  PLACA?: string;
  TIPO_VEICULO?: string;
  TIPO_COMBUSTIVEL?: string;
  POSTO?: string;
  OPERACAO?: string;
  HODOMETRO_ANTERIOR?: NumericValue;
  HODOMETRO_ATUAL?: NumericValue;
  VALOR_LITRO?: NumericValue;
  VALOR_ABASTECIMENTO?: NumericValue;
  QUANTIDADE_CALCULADO?: NumericValue;
  QUANTIDADE_ABASTECIDO?: NumericValue;
  MOTORISTA?: string;
  CONSUMO?: NumericValue;
}

const excelNumber = (value: NumericValue | undefined) => {
  if (value == null || String(value).trim() === '') return null;
  const number = Number(value);
  if (!Number.isFinite(number)) throw new Error('O relatório contém um valor numérico inválido.');
  return number;
};

const excelDate = (value?: string) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) throw new Error('O relatório contém uma data inválida.');
  // Excel nao armazena fuso: preservar o horario local exibido na tela.
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
};

export const criarRelatorioExcel = (rows: RelatorioItem[]) => {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet('Abastecimentos');
  sheet.columns = [
    { header: 'Data', width: 22, style: { numFmt: 'dd/mm/yyyy hh:mm' } },
    { header: 'Placa', width: 13 },
    { header: 'Tipo Veículo', width: 22 },
    { header: 'Tipo Combustível', width: 20 },
    { header: 'Posto', width: 32 },
    { header: 'Operação', width: 16 },
    { header: 'Hodômetro Ant.', width: 20, style: { numFmt: '#,##0' } },
    { header: 'Hodômetro Atual', width: 20, style: { numFmt: '#,##0' } },
    { header: 'Valor Litro', width: 18, style: { numFmt: '"R$" #,##0.000' } },
    { header: 'Valor Abastecimento', width: 25, style: { numFmt: '"R$" #,##0.00' } },
    { header: 'Quantidade Calculado', width: 25, style: { numFmt: '#,##0.000' } },
    { header: 'Quantidade Abastecido', width: 26, style: { numFmt: '#,##0.000' } },
    { header: 'Motorista', width: 40 },
    { header: 'Consumo', width: 16, style: { numFmt: '#,##0.00' } }
  ];
  rows.forEach((row) => sheet.addRow([
    excelDate(row.DATA), row.PLACA || '', row.TIPO_VEICULO || '',
    row.TIPO_COMBUSTIVEL || '', row.POSTO || '', row.OPERACAO || '',
    excelNumber(row.HODOMETRO_ANTERIOR), excelNumber(row.HODOMETRO_ATUAL),
    excelNumber(row.VALOR_LITRO), excelNumber(row.VALOR_ABASTECIMENTO),
    excelNumber(row.QUANTIDADE_CALCULADO), excelNumber(row.QUANTIDADE_ABASTECIDO),
    row.MOTORISTA || '', excelNumber(row.CONSUMO)
  ]));
  sheet.getRow(1).height = 32;
  sheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF234F78' } };
    cell.alignment = { vertical: 'middle', wrapText: true };
  });
  sheet.views = [{ state: 'frozen', ySplit: 1 }];
  sheet.autoFilter = { from: 'A1', to: `N${sheet.rowCount}` };
  return workbook;
};
